// extracted by mini-css-extract-plugin
module.exports = {"createButton":"NotesTab_createButton__3UHvN"};